// src/index.ts
import { Hono } from "./hono.js";
export {
  Hono
};
